export const ESTIMATE_DETAILS_SCREEN = 'estimate details'
export const JOB_DETAILS_SCREEN = 'job details'
export const REPORTS_SCREEN = 'reports'
export const NEW_ADD_JOB_SCREEN = 'new add job'
export const CUSTOMER_DETAILS_SCREEN = 'customer details'
export const DASHBOARD_SCREEN = 'dashboard'
